import React, { useState, useEffect } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import { FiFacebook, FiTwitter, FiInstagram, FiYoutube, FiMapPin, FiPhone, FiMail } from 'react-icons/fi';
import './BiographyPage.css';
import './GalleryPage.css';

const MosaicGrid = ({ cells }) => (
  <div className="gp-mosaic">
    {cells.map((cell, i) => (
      <div
        key={i}
        className={cell.cls}
        style={{ backgroundImage: `url('http://localhost:3001${cell.img}')` }}
      />
    ))}
  </div>
);

const GalleryPage = ({ onBack, onNavigate }) => {
  const [galleryImages, setGalleryImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchGalleryImages();
  }, []);

  const fetchGalleryImages = async () => {
    try {
      const response = await fetch('http://localhost:3001/api/gallery');
      const data = await response.json();
      
      if (data.success && data.images) {
        setGalleryImages(data.images);
      }
    } catch (error) {
      console.error('Failed to fetch gallery:', error);
    } finally {
      setLoading(false);
    }
  };

  // Distribute images into two grids with proper CSS classes
  const createGrids = () => {
    const rowClasses = [
      ['gp-cell-r1-1', 'gp-cell-r1-2', 'gp-cell-r1-3'],
      ['gp-cell-r2-1', 'gp-cell-r2-2', 'gp-cell-r2-3', 'gp-cell-r2-4'],
      ['gp-cell-r3-1', 'gp-cell-r3-2', 'gp-cell-r3-3']
    ];

    const grid1 = [];
    const grid2 = [];
    let imageIndex = 0;

    // Fill grid1
    for (const row of rowClasses) {
      for (const cellClass of row) {
        if (imageIndex < galleryImages.length) {
          grid1.push({
            cls: `gp-cell ${cellClass}`,
            img: galleryImages[imageIndex].imageUrl
          });
          imageIndex++;
        }
      }
      if (imageIndex >= galleryImages.length) break;
    }

    // Fill grid2 with remaining images
    for (const row of rowClasses) {
      for (const cellClass of row) {
        if (imageIndex < galleryImages.length) {
          grid2.push({
            cls: `gp-cell ${cellClass}`,
            img: galleryImages[imageIndex].imageUrl
          });
          imageIndex++;
        }
      }
      if (imageIndex >= galleryImages.length) break;
    }

    return { grid1, grid2 };
  };

  const { grid1, grid2 } = galleryImages.length > 0 ? createGrids() : { grid1: [], grid2: [] };
  const navigate = (target) => {
    if (onNavigate) onNavigate(target);
    else if (onBack) onBack();
  };

  return (
    <div className="gp-page">

      {/* Navbar */}
      <nav className="bio-navbar">
        <div className="bio-navbar-logo">
          <img src="/Sndp/logo.png" alt="Pravasi SNDP Yogam Logo" />
        </div>
        <div className="bio-navbar-links">
          <div className="bio-nav-menu">
            <a href="#home" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('home'); }}>Home</a>
            <div className="bio-nav-about-wrapper">
              <span className="bio-nav-link bio-nav-dropdown">
                About <FiChevronDown size={14} />
              </span>
              <div className="bio-nav-about-dropdown">
                <button onClick={() => navigate('ourhistory')}>Our History</button>
                <button onClick={() => navigate('leadership')}>Leadership</button>
              </div>
            </div>
            <a href="#gallery" className="bio-nav-link">Gallery</a>
            <a href="#news" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('news'); }}>News &amp; Articles</a>
            <a href="#eventcalendar" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('eventcalendar'); }}>Event Calendar</a>
            <a href="#constitution" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('constitution'); }}>Constitution</a>
            <a href="#membership" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('membership'); }}>Membership</a>
            <a href="#contact" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('contact'); }}>Contact Us</a>
          </div>
          <a href="#donate" className="bio-donate-btn">Donation</a>
        </div>
      </nav>

      {/* Page Title */}
      <div className="gp-title">
        <h1>Our Gallery</h1>
      </div>

      {loading ? (
        <p style={{ textAlign: 'center', padding: '3rem', color: '#666' }}>Loading gallery...</p>
      ) : galleryImages.length === 0 ? (
        <p style={{ textAlign: 'center', padding: '3rem', color: '#666' }}>No images in gallery yet.</p>
      ) : (
        <>
          {/* Mosaic Grid 1 */}
          {grid1.length > 0 && (
            <div className="gp-mosaic-wrapper">
              <MosaicGrid cells={grid1} />
            </div>
          )}

          {/* Mosaic Grid 2 */}
          {grid2.length > 0 && (
            <div className="gp-mosaic-wrapper">
              <MosaicGrid cells={grid2} />
            </div>
          )}
        </>
      )}

      {/* Footer */}
      <footer className="bio-footer">
        <div className="bio-footer-main">
          <div className="bio-footer-brand">
            <div className="bio-footer-logo-row">
              <img src="/Sndp/logo.png" alt="Logo" className="bio-footer-logo-img" />
              <div className="bio-footer-brand-info">
                <h3 className="bio-footer-brand-name">Pravasi SNDP Yogam, UK Bristol</h3>
                <p className="bio-footer-brand-desc">
                  We, Pravasi SNDP Yogam members, are the devotees of Sree Narayana Guru,
                  a revered saint and social reformer from Kerala, India (1854-1928).
                </p>
                <div className="bio-footer-socials">
                  <a href="#facebook" aria-label="Facebook"><FiFacebook size={20} color="#FFC501" /></a>
                  <a href="#twitter" aria-label="Twitter"><FiTwitter size={20} color="#FFC501" /></a>
                  <a href="#instagram" aria-label="Instagram"><FiInstagram size={20} color="#FFC501" /></a>
                  <a href="#youtube" aria-label="YouTube"><FiYoutube size={28} color="#FFC501" /></a>
                </div>
              </div>
            </div>
          </div>

          <div className="bio-footer-contact">
            <h4 className="bio-footer-column-title">Contact Us</h4>
            <div className="bio-footer-contact-list">
              <div className="bio-footer-contact-item">
                <FiMapPin size={20} color="#FFC501" />
                <span>Almondsbury Creative 10 Gloucester Road, Bristol</span>
              </div>
              <div className="bio-footer-contact-item">
                <FiPhone size={20} color="#FFC501" />
                <span>+91 84524145547</span>
              </div>
              <div className="bio-footer-contact-item">
                <FiMail size={20} color="#FFC501" />
                <span>sndpyogamuk@gmail.com</span>
              </div>
            </div>
          </div>

          <div className="bio-footer-links">
            <h4 className="bio-footer-column-title">Quick Links</h4>
            <ul className="bio-footer-nav">
              <li><a href="#home" onClick={onBack}>Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#gallery">Gallery</a></li>
              <li><a href="#news">News &amp; Articles</a></li>
              <li><a href="#events">Event Calendar</a></li>
              <li><a href="#constitution">Constitution</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="bio-footer-newsletter">
            <h4 className="bio-footer-column-title">Newsletter</h4>
            <p className="bio-newsletter-desc">Subscribe to our Newsletter</p>
            <div className="bio-newsletter-form">
              <input type="email" placeholder="Enter your email" />
              <button type="button">Subscribe</button>
            </div>
          </div>
        </div>

        <div className="bio-footer-bottom">
          <span>© 2025 Pravasi SNDP Yogam. All rights reserved.</span>
          <div className="bio-footer-bottom-links">
            <a href="#terms">Terms of Use</a>
            <a href="#privacy">Privacy Policy</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default GalleryPage;
